import React from 'react'
import { Route, Switch } from 'react-router-dom'

import LoginPage from './containers/LoginPage'
import HomePage from './containers/HomePage'
import CreatePage from './containers/CreatePage'
import TranscriptionPage from './containers/TranscriptionPage'

import NotFoundPage from './containers/NotFoundPage'

export default ({ childProps }) => (
  <Switch>
    <Route path='/' exact component={LoginPage} />
    <Route path='/app' exact component={HomePage} />
    <Route path='/app/create' exact component={CreatePage} />
    <Route
      path='/app/transcriptions/:transcriptionId'
      exact
      component={TranscriptionPage}
    />
    <Route component={NotFoundPage} />

  </Switch>
)



// WEBPACK FOOTER //
// ./src/Routes.js